function debugCookieExists() {
    return document.cookie.indexOf('debug=true') >= 0;
}

export const trace =
    // biome-ignore lint/suspicious/noExplicitAny: suppressed out of convenience for migration to biomejs
    import.meta.env.DEV || debugCookieExists() ? (...args: any) => console.log('[debug]', ...args) : () => {};
